import { useState, useEffect } from 'react';

const useMediaQuery = (width: string): boolean => {
  const [isMatch, setIsMatch] = useState(false);

  useEffect(() => {
    // Define the media query
    const mediaQuery = window.matchMedia(`(max-width: ${width})`);

    // Update the state based on the media query match
    const handleChange = () => setIsMatch(mediaQuery.matches);

    // Initial check
    handleChange();

    // Add event listener to handle changes
    mediaQuery.addEventListener('change', handleChange);

    // Cleanup event listener on component unmount
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [width]);

  return isMatch;
};

export default useMediaQuery;
